import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { VehiclesTable } from '~/components/settings/masterData/vehicle/VehiclesTable';

import { routeParams, validateSearch } from './-routeParams';

export const Route = createFileRoute('/(main)/settings/masterdata/vehicles/')({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/masterdata/vehicles',
    ...routeParams,
  }),
  component: VehiclesTable,
  validateSearch,
});

export const MASTERDATA_VEHICLES = buildRouteExport({ Route, ...routeParams });
